<template>
    <footer class="text-black-50 mt-5">
        <p>Nous aurons également besoin de certains documents complémentaires pour la finalisation de votre dossier. Vous pourrez nous les transmettre après votre règlement.</p>

        <p class="text-center">{{ copyright }}</p>
    </footer>
</template>

<script>
    export default {
        computed: {
            copyright() {
                const CURRENT_YEAR = new Date().getFullYear();
                return `© Assistel ${CURRENT_YEAR} - Tous droits réservés`
            }
        }
    }
</script>
